import { ActiveTabGameListActionType } from '../../types/activeTabGameListType'

export const setActiveTabGameList = (value: string) => {
    return {type: ActiveTabGameListActionType.SET_ACTIVE_TAB_GAME_LIST, payload: value}
}